export default {
  title: 'Revenue',
  tabs: {
    purchases: { title: 'Purchases' },
    badge: 'Coming soon',
    revenue: {
      title: 'Revenue',
      title_tag: 'Revenue - Revenue | Thanx',
      stats: {
        revenue: 'Net revenue attributed to loyalty members (%{month})',
      },
      chart: {
        date: 'Date',
        net_revenue: 'Net revenue attributed by channel',
      },
      table: {
        date_time: 'Month',
        member_purchases_instore_amount: 'In-store (loyalty)',
        member_purchases_total_amount: 'Total',
        member_purchases_digital_amount: 'Digital (loyalty)',
      },
      popovers: {
        example: 'Example',
        how_its_calculated: 'How it’s calculated',
        revenue_summary_popover: {
          section_1:
            'Revenue across all channels that was attributed to loyalty members.',
          section_2: 'This revenue is for the latest complete calendar month.',
          section_3: 'Thanx counted that loyalty members spent $3,000 in July.',
        },
        revenue_by_channel: {
          in_store: {
            percent: {
              section_1:
                'The percentage of your revenue attributed to in-store purchases made by loyalty members.',
              section_2:
                'In-store revenue counted by Thanx / Total revenue counted by Thanx.',
              section_3:
                '$10,000 was spent by all loyalty members across digital and in-store channels. $5,000 of that revenue came from in-store purchases made by loyalty members. That’s 50% of your revenue for the month.',
            },
            amount: {
              section_1:
                'Revenue attributed to in-store purchases made by loyalty members.',
              section_2: 'In-store revenue counted by Thanx.',
              section_3:
                '$5,000 of this month’s revenue came from in-store purchases made by loyalty members.',
            },
          },
          digital: {
            percent: {
              section_1:
                'The percentage of your revenue attributed to digital purchases (i.e., app and web) made by loyalty members.',
              section_2:
                'Digital revenue counted by Thanx / Total revenue counted by Thanx.',
              section_3:
                '$10,000 was spent by all loyalty members across digital and in-store channels. $5,000 of that revenue came from digital purchases made by loyalty members. That’s 50% of your revenue for the month.',
            },
            amount: {
              section_1:
                'Revenue attributed to digital purchases (i.e., app and web) made by loyalty members.',
              section_2: 'Digital revenue counted by Thanx.',
              section_3:
                '$5,000 of this month’s revenue came from digital purchases made by loyalty members.',
            },
          },
          total: {
            section_1:
              'Revenue across all channels that was attributed to loyalty members this month.',
            section_2: 'Total revenue counted by Thanx.',
            section_3:
              'Thanx counted that loyalty members spent $10,000 in July.',
          },
        },
      },
    },
    revenue_by_utm: {
      title: 'Revenue by UTM',
      title_tag: 'Revenue by UTM - Revenue | Thanx',
    },
    revenue_at_select_locations: {
      title: 'Revenue at select location(s)',
      title_tag: 'Revenue at select location(s) - Revenue | Thanx',
    },
    revenue_by_client: {
      title: 'Digital revenue by client',
      title_tag: 'Digital revenue by client - Revenue | Thanx',
    },
    revenue_by_handoff: {
      title: 'Digital revenue by handoff mode',
      title_tag: 'Digital revenue by handoff mode - Revenue | Thanx',
    },
    average_revenue_per_location_per_month: {
      title: 'Average revenue per location per month',
      title_tag: 'Average revenue per location per month - Revenue | Thanx',
    },
    average_check_overview: {
      title: 'Average check overview',
      title_tag: 'Average check overview - Revenue | Thanx',
    },
    average_check_by_location: {
      title: 'Average check by location',
      title_tag: 'Average check by location - Revenue | Thanx',
    },
    average_check_by_handoff_mode: {
      title: 'Average check by handoff mode',
      title_tag: 'Average check by handoff mode - Revenue | Thanx',
    },
  },
}
